<div class="modern-rotator" [class.disabled]="status">
  <svg class="rotator-svg" viewBox="0 0 100 100" (mousedown)="onMouseDown($event)">
    <!-- Background circle -->
    <circle class="rotator-track" cx="50" cy="50" r="35" />

    <!-- Active arc -->
    <circle class="rotator-progress"
      cx="50"
      cy="50"
      r="35"
      [style.stroke-dashoffset]="progressOffset" />

      <!-- Handle/Knob -->
      <g [attr.transform]="'rotate(' + rotated + ' 50 50)'">
        <!-- Handle circle -->
        <circle class="rotator-handle" cx="50" cy="15" r="8" />
      </g>
    </svg>

    <!-- Value display -->
    @if (showToolTop) {
      <div class="rotator-value">{{ rotated }}°</div>
    }

    <!-- Reset icon button -->
    <button mat-icon-button
      class="rotator-reset"
      (click)="resetRotation()"
      [disabled]="status || rotated === 0"
      matTooltip="Reset to 0°"
      matTooltipPosition="right">
      <mat-icon>restart_alt</mat-icon>
    </button>
  </div>
